import React, { Component } from "react";
import Loader from "../../components/loader";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });
class CommentPost extends Component {
  state = {};
  render() {
    const style = {
      display: "block",
      position: "absolute",
      margin: "0px",
      width: "100%",
      height: "100%"
    };
    const style_image = {
      position: "absolute",
      left: "0px",
      bottom: "0px"
    };
    if (this.props.loaded === false) {
      return <Loader loaded={this.props.loaded} />;
    }
    return (
      <div className="user_img" style={style_image}>
        <button
          style={style}
          className="btn btn_primary btn_yaystack no_border"
          onClick={this.props.handlerPostComment}
        >
          <label className="cursor_btn" style={{ textTransform: "none" }}>
            {strings.post}
          </label>
        </button>
      </div>
    );
  }
}

export default CommentPost;



// WEBPACK FOOTER //
// ./src/components/comments/comment_post.jsx